import { AxiosPromise } from "axios";

import api from "../../config/api-supplier-config";

interface ParametersPurchaseOrder {
  scheduled: boolean;
  onTime: boolean;
  lated: boolean;
}

export function getScheduleCalendar(
  storeId: any,
  initialPeriod: any,
  endPeriod: any
): AxiosPromise {
  return api.get(
    `v1/schedules/stores/${storeId}?initialPeriod=${initialPeriod}&endPeriod=${endPeriod}`,
    {}
  );
}

export function getScheduleCalendarById(id: any): AxiosPromise {
  return api.get(`v1/schedules/${id}`, {});
}

export function cancelSchedule(ids: any): AxiosPromise {
  return api.patch(`v1/schedules/cancel`, ids, {});
}

export function getScheduleDateAvaliableById(
  productId: any,
  document: any,
  supplierId: any
): AxiosPromise {
  return api.get(
    `v1/schedules/documents/${document}/suppliers/${supplierId}/products/${productId}/available-dates`,
    {}
  );
}

export function postInventory(obj: any): AxiosPromise {
  return api.post("v1/schedules/inventories", obj, {});
}

export function confirmReSchedule(obj: any): AxiosPromise {
  return api.post("v1/schedules", obj, {});
}

export function saveReSchedulePatch(obj: any): AxiosPromise {
  return api.patch("v1/schedules/quantities", obj, {});
}

//DASHBOARD

export function getScheduleDashboardWeek(
  store: any,
  start: any,
  end: any
): AxiosPromise {
  return api.get(
    "v1/reports/stores/" +
      store +
      "/weeks?initialPeriod=" +
      start +
      "&endPeriod=" +
      end,
    {}
  );
}

export function getScheduleDashboardDay(store: any, date: any): AxiosPromise {
  return api.get("v1/reports/stores/" + store + "/days?date=" + date, {});
}

export function getScheduleDashboarExport(
  store: any,
  initDate: any,
  endDate: any,
  sector: any
): AxiosPromise {
  return api.get(
    `v1/schedules/stores/${store}/export?sector=${sector}&initialPeriod=${initDate}&endPeriod=${endDate}`,
    {}
  );
}

export default {
  getScheduleCalendar,
  getScheduleCalendarById,
  getScheduleDateAvaliableById,
  postInventory,
  confirmReSchedule,
  cancelSchedule,
  saveReSchedulePatch,
  getScheduleDashboardWeek,
  getScheduleDashboardDay,
  getScheduleDashboarExport,
};
